export default {
  path: '/date-match-rule',
  component: () => import('./DateGroupMatchRule'),
  meta: {
    title: '配对规则',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
